// src/utils/constants.js

/**
 * Tipos de inspecciones disponibles en el sistema
 */
export const TIPOS_INSPECCIONES = [
    { id: "ENSAYO", descripcion: "Ensayo" },
    { id: "VERIFICACION", descripcion: "Verificación" },
    { id: "VENCIMIENTO", descripcion: "Vencimiento" },
    { id: "CONTROL_CARGA", descripcion: "Control de Carga" },
    { id: "CONTROL_HIDRO", descripcion: "Control Hidrostático" },
    { id: "PATENTE", descripcion: "Patente" },
    { id: "SEGURO", descripcion: "Seguro" },
    { id: "MARINE_BUREAU", descripcion: "Marine Bureau" },
    { id: "MARRERO", descripcion: "Marrero" },
    { id: "APPLUS", descripcion: "Applus" },
    { id: "PERMISO_NAC_CIRCULACION", descripcion: "Permiso Nacional de Circulación" },
    { id: "CONTROL_EPP_EPC", descripcion: "Control de entrega, uso y mantenimiento de EPP y EPC" },
    { id: "EVAL_CONDICIONES", descripcion: "Evaluación de Condiciones de Trabajo" },
    { id: "INSPECCION_R16", descripcion: "Inspección R16 (UTE)" },
    { id: "INSPECCION_TEC_COMERCIAL", descripcion: "Inspección Equipo Técnico Comercial" },
    { id: "MANTENIMIENTO", descripcion: "Mantenimiento de Máquinas y Herramientas" },
  ];

  export const TIPOS_INSPECCIONES_PERSONAS = [
    { id: "CONTROL_EPP_EPC", descripcion: "Control de entrega, uso y mantenimiento de EPP y EPC" },
    { id: "EVAL_CONDICIONES", descripcion: "Evaluación de Condiciones de Trabajo" },
    { id: "INSPECCION_R16", descripcion: "Inspección R16 (UTE)" },
    { id: "INSPECCION_TEC_COMERCIAL", descripcion: "Inspección Equipo Técnico Comercial" },
    { id: "MANTENIMIENTO", descripcion: "Mantenimiento de Máquinas y Herramientas" },
  ];

  export const TIPOS_INSPECCIONES_EQUIPOS = [
    { id: "ENSAYO", descripcion: "Ensayo" },
    { id: "VERIFICACION", descripcion: "Verificación" },
    { id: "VENCIMIENTO", descripcion: "Vencimiento" },
    { id: "CONTROL_CARGA", descripcion: "Control de Carga" },
    { id: "CONTROL_HIDRO", descripcion: "Control Hidrostático" },
    { id: "PATENTE", descripcion: "Patente" },
    { id: "SEGURO", descripcion: "Seguro" },
    { id: "MARINE_BUREAU", descripcion: "Marine Bureau" },
    { id: "MARRERO", descripcion: "Marrero" },
    { id: "APPLUS", descripcion: "Applus" },
    { id: "INSPECCION_TEC_COMERCIAL", descripcion: "Inspección Equipo Técnico Comercial" },
    { id: "PERMISO_NAC_CIRCULACION", descripcion: "Permiso Nacional de Circulación" },
  ];
  
  /**
   * Tipos de capacitaciones disponibles en el sistema
   */
  export const TIPOS_CAPACITACIONES = [
    { id: "TCT", descripcion: "TCT" },
    { id: "ALTURA_Y_MOTOSIERRA", descripcion: "Trabajo en Altura y con Motosierra" },
    { id: "TRABAJO_SEGURO", descripcion: "Trabajo Seguro" },
    { id: "JORNADA_INICIAL", descripcion: "Jornada Inicial" },
    { id: "JORNADA_DE_SEGURIDAD", descripcion: "Jornada de Seguridad" },
    { id: "UTE_INSPECCIONES", descripcion: "Respuesta a Inspecciones de UTE" },
    { id: "DECRETO125", descripcion: "Inducción general a la obra según el decreto 125/14" },
    { id: "NS1D", descripcion: "NS1D" },
    { id: "SANCION", descripcion: "No Conformidad" },
    { id: "DOCUMENTO_SIG", descripcion: "Distribución de Documentos del SIG - 2020" },
    { id: "JORNADA_CALIDAD", descripcion: "Jornada de Calidad" },
    { id: "JORNADA_CALIDAD_SEGURIDAD", descripcion: "Jornada de Calidad-Seguridad" },
    { id: "MEJORA_PERFIL_CARGO", descripcion: "Mejora del perfil de cargo" },
    { id: "TRABAJO_EN_ALTURA", descripcion: "Trabajo en altura" },
    { id: "USO_SEGURO_MOTOSIERRA", descripcion: "Uso seguro de motosierra" },
  ];
  
  /**
   * Tipos de equipos disponibles en el sistema
   */
  export const TIPOS_EQUIPOS = [
    { id: "EPP", descripcion: "EPP" },
    { id: "EPC", descripcion: "EPC" },
    { id: "HERRAMIENTA", descripcion: "Herramienta" },
    { id: "MAQUINA", descripcion: "Máquina" },
    { id: "CAMION", descripcion: "Camión" },
    { id: "CAMION_GRUA", descripcion: "Camión c/grúa" },
    { id: "AUTO", descripcion: "Auto" },
    { id: "CAMIONETA", descripcion: "Camioneta" },
  ];
  
  /**
   * Tipos de documentos comunes en el sistema
   */
  export const TIPOS_DOCUMENTOS = [
    { id: "CEDULA", descripcion: "Cédula de Identidad" },
    { id: "CARNET_SALUD", descripcion: "Carnet de Salud" },
    { id: "LICENCIA_CONDUCIR", descripcion: "Licencia de Conducir" },
    { id: "CERT_CAPACITACION", descripcion: "Certificado de Capacitación" },
    { id: "CONTRATO_TRABAJO", descripcion: "Contrato de Trabajo" },
    { id: "SEGURO", descripcion: "Seguro" },
    { id: "TITULO_PROFESIONAL", descripcion: "Título Profesional" },
    { id: "OTRO", descripcion: "Otro Documento" },
  ];
  
  /**
   * Tipos de género disponibles
   */
  export const TIPOS_GENERO = [
    { id: "M", descripcion: "Masculino" },
    { id: "F", descripcion: "Femenino" },
    { id: "O", descripcion: "Otro" },
  ];
  
  /**
   * Tipos de persona disponibles
   */
  export const TIPOS_PERSONA = [
    { id: "F", descripcion: "Persona Física" },
    { id: "J", descripcion: "Persona Jurídica" },
  ];
  
  /**
   * Regímenes de persona disponibles
   */
  export const REGIMENES_PERSONA = [
    { id: "Empleado", descripcion: "Empleado" },
    { id: "Cliente", descripcion: "Cliente" },
    { id: "Subcontrato", descripcion: "Subcontratado" },
  ];
  
  /**
   * Función helper para obtener la descripción de un tipo a partir de su ID
   * @param {string} tipoId - ID del tipo
   * @param {Array} listaTipos - Lista de tipos donde buscar
   * @returns {string} - Descripción del tipo o el ID si no se encuentra
   */
  export const getTipoDescripcion = (tipoId, listaTipos) => {
    if (!tipoId) return '';
    const tipo = listaTipos.find(item => item.id === tipoId);
    return tipo ? tipo.descripcion : tipoId;
  };
  
  export const getDescripcionGenero = (genderId, tiposGenero) => 
    tiposGenero.find(g => g.id === genderId)?.descripcion || genderId;
  
  export const getDescripcionPais = (countryId, paises) => 
    paises.find(p => p.id === countryId)?.descripcion || countryId;
  
  /**
   * Formato de fecha para mostrar en la aplicación
   */
  export const FORMATO_FECHA = 'DD/MM/YYYY';
  
  /**
   * Países disponibles (simplificado)
   */
  export const PAISES = [
    { id: "UY", descripcion: "Uruguay" },
    { id: "AR", descripcion: "Argentina" },
    { id: "BR", descripcion: "Brasil" },
    { id: "CL", descripcion: "Chile" },
    { id: "PY", descripcion: "Paraguay" },
    { id: "O", descripcion: "Otro" },
  ];
  
  /**
   * Estados civiles disponibles
   */
  export const ESTADOS_CIVILES = [
    { id: "Soltero", descripcion: "Soltero/a" },
    { id: "Casado", descripcion: "Casado/a" },
    { id: "Divorciado", descripcion: "Divorciado/a" },
    { id: "Viudo", descripcion: "Viudo/a" },
    { id: "Union_Libre", descripcion: "Unión Libre" },
  ];
  
  /**
   * Tipos de documentos de identidad
   */
  export const TIPOS_DOCUMENTO_IDENTIDAD = [
    { id: "CI", descripcion: "CI" },
    { id: "PASAPORTE", descripcion: "Pasaporte" },
    { id: "RUT", descripcion: "RUT" },
  ];